import { getConfig } from "@config/index";
export const CURRENT_BASE_URL = getConfig().BASE_URL + "/"; //"http://146.56.48.145:8081/";
export const CURRENT_FORM_URL = getConfig().FORM_BASE_URL; //"http://146.56.48.145:8080/";
export const SOCIAL_UTILITY_BASE_URL = getConfig().SOCIAL_UTILITY_BASE_URL; //"http://146.56.48.145:8082/";
export const INFOGRAPHICS_BASE_URL = getConfig().INFOGRAPHICS_BASE_URL;
export const TENAX_BASE_URL = getConfig().TENAX_BASE_URL;
// export const CURRENT_BASE_URL = "https://accounts.munshify.com/";
// export const CURRENT_FORM_URL = "https://formsapi.munshify.com/";
